// listas.js

export const listaFezComMedcontabilNoAnoPassado = [
  { id: 1, label: "NÃO" },
  { id: 2, label: "SIM" },
];

export const listaVaiFazerNoProximoAno = [
  { id: 1, label: "NÃO" },
  { id: 2, label: "SIM" },
];

export const listaMensagem = [
  { id: 1, label: "ENVIADA" },
  { id: 2, label: "RESPONDIDO" },
  { id: 3, label: "NÃO RESPONDIDO" }
];

export const listaSituacao = [
  { id: 1, label: "ENTREGUE" },
  { id: 2, label: "PENDÊNCIA" },
  { id: 3, label: "AGUARDANDO PAGAMENTO" },
  { id: 4, label: "EM PREENCHIMENTO" },
  { id: 5, label: "NÃO OBRIGADA" },
  { id: 6, label: "NÃO INICIADA" },
  { id: 7, label: "DOCUMENTOS ENVIADOS" }
];

export const listaRestituirOuAPagar = [
  { id: 1, label: "RESTITUIR" },
  { id: 2, label: "PAGAR" },
  { id: 3, label: "SEM VALOR" }
];

export const listaFies = [
  { id: 1, label: "NÃO" },
  { id: 2, label: "SIM" }
];

export const listaBoleto = [
  { id: 1, label: "PAGO" },
  { id: 2, label: "MEDPRO" },
  { id: 3, label: "MEDSTART" }
];

export const listaMalha = [
  { id: 1, label: "NÃO" },
  { id: 2, label: "SIM" }
];
